// Named ids for the user types referenced directly in FE gating logic (see repTypes.js for the
// rep-type equivalent, which these ids happen to mirror for these three rows). Backs the Manage
// Users filter bar's user-type-based thresholds (TMMFX-3652).
export const USER_TYPE_IDS = {
    globalAdmin: 1,
    businessUnitManager: 2,
    regionalSalesManager: 3,
};
